import React from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { aggregateData } from "./util";
import { CostsData } from "./useCostsData";
import { formatNumber } from "../../financial/utils";

interface CostsTooltipProps {
  active?: boolean;
  payload?: { value: number }[];
  label?: string;
}
const CostsTooltip = ({ active, payload }: CostsTooltipProps) => {
  if (!active || !payload || !payload[0].value) return null;
  return <>{formatNumber(payload[0].value, true)}</>;
};
interface DashboardCostsGraphProps {
  data: CostsData;
}
const DashboardCostsGraph = ({ data }: DashboardCostsGraphProps) => {
  const calcData = aggregateData(data);
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={calcData}
        margin={{
          left: 0,
          right: 0,
        }}
      >
        <XAxis dataKey="name" interval={0} axisLine={false} tickLine={false} />
        <Tooltip content={<CostsTooltip />} />
        <Bar
          radius={2}
          dataKey="costs"
          stackId="type"
          fill="#DBE9F7" // blue-200
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DashboardCostsGraph;
